// Generated by purs version 0.15.7
import * as Control_Alt from "../Control.Alt/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_String_CodeUnits from "../Data.String.CodeUnits/index.js";
import * as Machine from "../Machine/index.js";
import * as Parser from "../Parser/index.js";
var $runtime_lazy = function (name, moduleName, init) {
    var state = 0;
    var val;
    return function (lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var map = /* #__PURE__ */ Data_Functor.map(Parser.parserFunctor);
var alt = /* #__PURE__ */ Control_Alt.alt(Parser.parserAlternative);
var applyFirst = /* #__PURE__ */ Control_Apply.applyFirst(Parser.parserApply);
var apply = /* #__PURE__ */ Control_Apply.apply(Parser.parserApply);
var applySecond = /* #__PURE__ */ Control_Apply.applySecond(Parser.parserApply);
var ws = /* #__PURE__ */ Parser.re("\\s*");
var $$this = /* #__PURE__ */ Parser.re("\u543e");
var period = /* #__PURE__ */ Parser.re("\\s*(\u3002?)\\s*");
var identifier = /* #__PURE__ */ (function () {
    return map(Data_String_CodeUnits.slice(1)(-1 | 0))(Parser.re("(\u300c|\u300e).+?(\u300d|\u300f)"));
})();
var loadValue = /* #__PURE__ */ (function () {
    var quote = function (s) {
        return "\"" + (s + "\"");
    };
    return alt(applyFirst(apply(map(Data_Function["const"](Machine.LoadVal.create))(Parser.re("(\u6709|\u4ee5)")))(identifier))(period))(applyFirst(apply(map(Data_Function["const"](function ($13) {
        return Machine.LoadVal.create(quote($13));
    }))(Parser.re("\u6709\u8a00")))(identifier))(period));
})();
var makeNode = /* #__PURE__ */ (function () {
    return applyFirst(apply(map(Data_Function["const"](Machine.MakeNode.create))(Parser.re("\u6709\u6b64")))(identifier))(period);
})();
var path = /* #__PURE__ */ apply(/* #__PURE__ */ map(Data_Array.cons)(/* #__PURE__ */ alt(identifier)($$this)))(/* #__PURE__ */ Parser.sepBy(ws)(/* #__PURE__ */ applySecond(/* #__PURE__ */ Parser.re("\u4e4b"))(identifier)));
var loadVariable = /* #__PURE__ */ (function () {
    return applyFirst(apply(map(Data_Function["const"](Machine.LoadRef.create))(Parser.re("(\u53d6|\u592b)(\u5176|\u5f7c)?")))(path))(period);
})();
var storeVariable = /* #__PURE__ */ (function () {
    return alt(applyFirst(applyFirst(apply(map(Data_Function["const"](Machine.Store.create))(Parser.re("\u4eca")))(path))(Parser.re("(\u5982\u662f|\u4ea6\u7136)")))(period))(applyFirst(apply(map(Data_Function["const"](Machine.Store.create))(Parser.re("\u662f?\u8b02")))(path))(period));
})();
var setMember = /* #__PURE__ */ (function () {
    return alt(applyFirst(applyFirst(apply(applyFirst(applyFirst(applyFirst(apply(map(Data_Function["const"](Machine.SetRef.create))(Parser.re("\u5176")))(identifier))(Parser.re("\u8005")))(ws))(Parser.re("\u5f7c")))(path))(Parser.re("\u4e5f")))(period))(applyFirst(apply(applyFirst(applyFirst(apply(map(Data_Function["const"](Machine.SetVal.create))(Parser.re("\u5176")))(identifier))(Parser.re("\u4e5f?")))(ws))(identifier))(period));
})();
var call = /* #__PURE__ */ (function () {
    return alt(applyFirst(applyFirst(apply(apply(map(Data_Function["const"](Machine.Call.create))(Parser.re("\u9858\u5f7c?")))(path))(identifier))(Parser.re("\u4e4b?")))(period))(alt(applyFirst(applyFirst(apply(applyFirst(apply(map(Data_Function["const"](Machine.Call.create))(Parser.re("\u5f7c")))(path))(Parser.re("\u5176")))(identifier))(Parser.re("\u8005\u4f55")))(period))(alt(applyFirst(applyFirst(apply(map(Data_Function["const"](Machine.Call.create([ "\u543e" ])))(Parser.re("\u543e(\u6b32|\u7576)")))(identifier))(Parser.re("\u4e4b?")))(period))(applyFirst(applyFirst(apply(map(Data_Function["const"](Machine.Call.create([ "\u4e16" ])))(Parser.re("\u8acb")))(identifier))(Parser.re("\u4e4b?")))(period))));
})();
var binaryOperation = /* #__PURE__ */ (function () {
    return applyFirst(applyFirst(map(Machine.BinOp.create)(identifier))(Parser.re("\u4e4b")))(period);
})();
var $lazy_block = /* #__PURE__ */ $runtime_lazy("block", "Syntax", function () {
    return Parser.altLazy(Parser.noop)(function (v) {
        return applyFirst(applyFirst(applySecond(applySecond(Parser.re("\u300c|\u300e"))(ws))(Parser.sepBy(ws)($lazy_instruction(82))))(ws))(Parser.re("\u300d|\u300f"));
    });
});
var $lazy_instruction = /* #__PURE__ */ $runtime_lazy("instruction", "Syntax", function () {
    return Parser.altLazy(Parser.altLazy(alt(loadValue)(alt(loadVariable)(alt(binaryOperation)(alt(storeVariable)(alt(makeNode)(alt(setMember)(call)))))))(function (v) {
        return $lazy_register(37);
    }))(function (v) {
        return $lazy_selection(38);
    });
});
var $lazy_register = /* #__PURE__ */ $runtime_lazy("register", "Syntax", function () {
    return Parser.altLazy(Parser.noop)(function (v) {
        return apply(applyFirst(apply(map(Data_Function["const"](Machine.Register.create))(Parser.re("\u805e")))(identifier))(Parser.re("\u5247\u7b54\u66f0")))($lazy_block(102));
    });
});
var $lazy_selection = /* #__PURE__ */ $runtime_lazy("selection", "Syntax", function () {
    return Parser.altLazy(Parser.noop)(function (v) {
        return alt(apply(applyFirst(applyFirst(applyFirst(apply(applyFirst(applyFirst(map(Data_Function["const"](Machine.Select.create))(Parser.re("\u7136")))(period))(ws))($lazy_block(88)))(ws))(Parser.re("\u4e0d\u7136")))(period))($lazy_block(88)))(alt(apply(applyFirst(map(Data_Function["const"](Data_Function.flip(Machine.Select.create)([  ])))(Parser.re("\u7136")))(period))($lazy_block(92)))(apply(applyFirst(map(Data_Function["const"](Machine.Select.create([  ])))(Parser.re("\u4e0d\u7136")))(period))($lazy_block(96))));
    });
});
var block = /* #__PURE__ */ $lazy_block(78);
var instruction = /* #__PURE__ */ $lazy_instruction(28);
var register = /* #__PURE__ */ $lazy_register(98);
var selection = /* #__PURE__ */ $lazy_selection(84);
var program = /* #__PURE__ */ applyFirst(/* #__PURE__ */ applySecond(ws)(/* #__PURE__ */ Parser.sepBy(ws)(instruction)))(ws);
export {
    ws,
    period,
    identifier,
    $$this as this,
    path,
    program,
    instruction,
    loadValue,
    loadVariable,
    binaryOperation,
    storeVariable,
    makeNode,
    setMember,
    block,
    selection,
    register,
    call
};
